import api from '../../api/nodeBackApi';

// Slot-change history for a customer, newest first.
export const getSlotAuditLogs = async (customerId) => {
  try {
    const response = await api.get(`/api/management/customers/byCustomerId/${customerId}/slot-audit-logs`);
    return response.data;
  } catch (error) {
    console.error('Error fetching slot audit logs:', error);
    throw error;
  }
};
